<template>
  <div class="p-ds-wrap">
    <div class="p-ds-header">
      <span class="p-ds-title">日程安排</span>
      <div class="p-ds-filter">
        <el-checkbox
          v-model="hasEndTime"
          class="p-ds-checkbox"
          @change="changeTaskType"
        />
        <span
          class="p-ds-filter-label"
          @click="hasEndTime=!hasEndTime,changeTaskType()"
        >显示有截止日期的任务</span>
      </div>
      <task-filter-group
        :users="users"
        :showStatus="true"
        :defaultStatus="defaultStatus"
        class="p-ds-owner"
      />
      <search-value @keyUp="handleScreenInfo"></search-value>
      <i class="p-ds-full-screen ibass ibass-fullScreen" :class="{'ibass-defaultScreen': !showFull}" @click="handleFullScreen"></i>
    </div>
    <div class="p-ds-handle">
      <div class="p-ds-handle-left">
        <calendar-switch
          :viewType="currentViewType"
          @change="changeViewType"
        />
        <div
          class="p-ds-back"
          @click="backToToday"
        >
          <i class="ibass ibass-back" />今天
        </div>
      </div>
      <div class="p-ds-handle-center">
        <calendar-picker
          :viewType="currentViewType"
          :date="curDate"
          @click="changeDate"
        />
        <task-tags v-if="currentViewType === 'days'" :tags="tags" />
      </div>
      <div
        v-if="isNewVersion"
        class="p-ds-handle-sync"
      >
        <el-tooltip effect="dark" content="立项时填写的时间信息将自动同步到日历" placement="top">
          <i class="ibass ibass-info"></i>
        </el-tooltip>
      </div>
    </div>
    <div
      class="p-ds-views"
      v-loading="loading"
      @mouseenter="mouseenter"
      @mousemove="mousemove"
      @mouseleave="mouseleave"
    >
      <component
        :is="currentView"
        :curDate="curDate"
      />
      <span
        class="p-ds-tip"
        v-show="showTitle"
        :style="{
          left: x + 'px',
          top: y + 'px'
        }"
      >点击或上下拖拽</span>
    </div>
  </div>
</template>
<script>
import CalendarSwitch from './components/calendarSwitch'
import CalendarPicker from './components/calendarPicker'
import DaysView from './components/days/daysView'
import MonthView from './components/month/monthView'
import WeekView from './components/week/weekView'
import YearView from './components/year/yearView'
import TaskFilterGroup from '@/components/task-filter-group'
import { TASK_STATUS } from '@/utils/constants'
import db from '@/plugin/db'
import taskService from '@/pages/index/service/calendar'
import IlawService from '@/pages/index/service/ilaw'
import SearchValue from './components/search'
import TaskTags from '@/biz-components/task-tags/index.vue'
export default {
  name: 'PDailySchedule',
  components: {
    TaskTags,
    CalendarSwitch,
    CalendarPicker,
    DaysView,
    MonthView,
    WeekView,
    YearView,
    TaskFilterGroup,
    SearchValue
  },
  data () {
    return {
      hasEndTime: true,
      isNewVersion: localStorage.officeVersion === 'newVersion',
      curDate: moment().format('YYYY-MM-DD'),
      currentView: '',
      currentViewType: 'week',
      users: [],
      tasks: [],
      loading: false,
      storeKey: `workbench_calendar_type`,
      showTitle: false,
      x: 0,
      y: 0,
      showFull: true,
      formInfo: {
        searchValue: '',
        reqParams: {}
      },
      tags: 0
    }
  },
  computed: {
    defaultStatus () {
      // 过滤条件
      let res = Object.values(TASK_STATUS).filter(status => status.value !== TASK_STATUS.DELETED.value)
      res.unshift({ value: '', label: '全部' })
      return res
    }
  },
  watch: {
    '$store.state.calendar.reqParams': {
      handler: function (newVal, oldVal) {
        // 添加判断，必须要有时间范围的时候才进行请求
        if (newVal.rangeFrom && newVal.rangeTo) {
          this.getMyTasks(newVal)
          this.formInfo.reqParams = newVal
        }
      },
      deep: true
    },
    '$store.state.calendar.createTaskParams': {
      handler (newer, older) {
        this.$postMessage.createTask(newer, (data) => {
          if (data && data.status === 'success') {
            this.$store.commit('updateCalendarParams')
          }
          // 创建任务弹层取消则清除拖动产生的临时任务
          if (data && data.status === 'cancel') {
            this.$set(this.$store.state.calendar.tasks, 0, {})
          }
        })
      },
      deep: true
    },
    '$store.state.calendar.viewType': {
      handler: function (newer, older) {
        this.setViewType(newer.type)
        this.storeCalendarType(newer.type)
        if (newer.date) {
          this.curDate = moment(newer.date).format('YYYY-MM-DD')
        }
      },
      deep: true
    },
    '$store.state.calendar.AllTasks': {
      handler (newer) {
        let tasks = newer.filter(task => {
          return this.hasEndTime ? true : (task.dayType === 1 || !task.dueTime)
        })
        this.tasks = JSON.parse(JSON.stringify(tasks))
        this.tasks.unshift({})
        this.$store.commit('updateCalendarTasks', this.tasks)
      },
      deep: true
    }
  },
  created () {
    this.initReqParams()
    let curType = db.ls.get(this.storeKey) || 'week'
    this.setViewType(curType)
    this.getAttorney()
    if (this.$route.path === '/DailySchedule') {
      this.showFull = false
    }
  },
  methods: {
    mouseenter (e) {
      if (this.currentViewType !== 'year') {
        this.showTitle = true
        let elPos = document.querySelector('.p-ds-wrap').getClientRects()[0]
        this.x = e.clientX - elPos.left
        this.y = e.clientY - elPos.top + 16
      }
    },
    mousemove (e) {
      if (this.currentViewType !== 'year') {
        let elPos = document.querySelector('.p-ds-wrap').getClientRects()[0]
        this.x = e.clientX - elPos.left
        this.y = e.clientY - elPos.top + 16
      }
    },
    mouseleave (e) {
      if (this.currentViewType !== 'year') {
        this.showTitle = false
        this.x = 0
        this.y = 0
      }
    },
    // 有权限看到的成员列表
    async getAttorney () {
      try {
        let result = await IlawService.searchByCreateUserId()
        let _users = []
        let _idsSet = new Set()
        result.result.forEach(item => {
          item.members.forEach(member => {
            if (!_idsSet.has(member.userId)) {
              _users.push(member)
              _idsSet.add(member.userId)
            }
          })
        })
        _users.unshift({
          userId: this.$store.state.user.user.id,
          userName: this.$store.state.user.user.name,
          userPic: this.$store.state.user.user.pic,
          pinyin: this.$store.state.user.user.pinyin
        })
        this.users = _users
      } catch (e) {
        this.users = []
      }
    },
    initReqParams () {
      let filters = db.ls.get('transCalendarTaskFilters')
      if (!filters) {
        filters = db.ls.get('transTaskFilters')
        db.ls.set('transCalendarTaskFilters', filters)
      }
      let reqParams = {
        matters: filters && filters.matters && filters.matters.length > 0 ? filters.matters : [],
        users: filters && filters.users && filters.users.length > 0 ? filters.users : [this.$store.state.user.user]
      }
      this.$store.commit('updateCalendarParams', reqParams)
    },
    async getMyTasks (reqParams) {
      let params = {
        matterIds: reqParams.matters.map(matter => matter.id),
        matterId: '',
        userIds: reqParams.users.map(user => user.userId),
        rangeFrom: reqParams.rangeFrom,
        rangeTo: reqParams.rangeTo,
        random: reqParams.random,
        state: reqParams.status === '' ? '' : reqParams.status - 1,
        searchValue: this.formInfo.searchValue
      }
      this.loading = true
      let result = []
      try {
        // if (this.matterId) {
        //   result = await taskService.getMatterCalendarTask(params)
        // } else
        if (params.userIds.length === 1 && params.userIds[0] === this.$store.state.user.user.id) {
          result = await taskService.getMyTasks(params)
        } else {
          result = await taskService.getCalendarTask(params)
        }
        // this.tasks = result.data || []
        let tasks = result.data || []
        // 用于拖动创建任务的临时位
        // this.tasks.unshift({})
        this.$store.commit('setCalendarAllTasks', tasks.slice(0))
        this.loading = false
        this.tags = tasks.reduce((tags, task) => {
          return tags | task.tags
        }, 0)
      } catch (e) {
        this.tasks = []
        this.loading = false
      }
    },
    // 过滤是否要显示只有截止时间的数据
    changeTaskType () {
      this.loading = true
      // 刷新任务列表
      let tasks = this.$store.state.calendar.AllTasks || []
      this.tasks = tasks.filter(task => {
        return this.hasEndTime ? true : (task.dayType === 1 || !task.dueTime)
      })
      this.$store.commit('updateCalendarTasks', this.tasks)
      setTimeout(() => {
        this.loading = false
      }, 300)
      if (this.hasEndTime) {
        this.$analysis.track('显示有截止日期的任务_日程安排/工作台模块')
      } else {
        this.$analysis.track('取消显示有截止日期的任务_日程安排/工作台模块')
      }
    },
    storeCalendarType (type) {
      db.ls.set(this.storeKey, type)
    },
    changeViewType (view) {
      this.$store.commit('setCalendarViewType', {
        type: view
      })
    },
    setViewType (view) {
      let vName = view.replace(/^\S/, L => L.toUpperCase())
      this.currentView = `${vName}View`
      this.currentViewType = view
    },
    backToToday () {
      this.curDate = moment().format('YYYY-MM-DD HH:mm:ss')
      this.$analysis.track('点击今天_日程安排/工作台模块')
    },
    changeDate (date) {
      this.curDate = moment(date).startOf(this.currentViewType).format('YYYY-MM-DD')
      this.$analysis.track('切换日期_日程安排/工作台模块')
    },
    handleFullScreen () {
      window.open('/#/app/my/task/calendar?_=' + new Date().getTime())
      // if (this.showFull) {
      //   this.$router.push('/DailySchedule')
      // } else {
      //   this.$router.push('/')
      // }
    },
    handleScreenInfo (searchValue) {
      Object.assign(this.formInfo, { searchValue })

      this.getMyTasks(this.formInfo.reqParams)
      this.$store.commit('upDataSearchValue', searchValue)
    }
  }
}
</script>
<style lang="stylus">
.p-ds
  &-title
    color #000
  &-wrap
    position relative
    padding 15px 0 15px 30px
    box-sizing border-box
  &-header
    display flex
    flex-wrap nowrap
    align-items center
    position relative
  &-view
    position relative
  &-tip
    position absolute
    display block
    background-color rgba(0, 0, 0, .8)
    padding 0 8px
    height 26px
    line-height 26px
    color #ffffff
    white-space nowrap
    font-size 12px
    border-radius 2px
    z-index 30
  &-filter
    display inline-block
    margin-left 20px
    &-label
      cursor pointer
  &-owner
    display inline-block
    margin-left 20px
  &-full-screen
    position absolute
    font-size 20px
    right 20px
    cursor pointer
  &-handle
    margin-top 10px
    display flex
    justify-content space-between
    .el-loading-mask
      top 200px
    &-left
      padding-top 4px
    &-center
      display: flex
      align-items: center
      .task-tags
        margin-left: 8px
        transform: translateY(-2px)
    &-sync
      margin 9px 18px 0 0
      color #999
  &-checkbox
    margin-right 5px
  &-back
    display inline-block
    margin-left 15px
    cursor pointer
    .ibass-back
      color #cdc9c5
      margin-right 5px
    &:hover
      color #ed6c00
      .ibass-back
        color #ed6c00
</style>
